import { agreementStatusToStr } from '@/_schemas/agreements/agreement-status-schema';
import { pipelineToStr } from '@/_schemas/agreements/agreements-pipeline-schemas';

import type { AgreementNewFormSchema, AgreementsCreateSchema } from '../schemas';

export function agreementFormToCreate({
  status,
  agreement_date,
  expiry_date,
  client,
  pipeline,
  primary_domains,
  account_manager,
  agreement_id,
  billing_term,
  addresses,
  parent_id,
}: AgreementNewFormSchema): AgreementsCreateSchema {
  return {
    status: agreementStatusToStr(status),
    agreement_date,
    expiry_date,

    client_id: client?.id ?? -1,
    pipeline: pipelineToStr(pipeline, !!parent_id),
    primary_domains: primary_domains?.id ? [primary_domains?.id ?? -1] : null,
    account_manager: account_manager?.map((item, i) => ({ id: item.id, sort_order: i + 1 })) ?? [],
    billing_term_id: billing_term?.id ?? null,
    agreement_id,
    brand_id: client?.brand?.id ?? null,
    partner_id: client?.partner?.id ?? null,
    agreement_installments: [],
    addresses: addresses?.map((address) => address.id) ?? [],
    parent_id,
  };
}
